import { CDN_URLS } from '../../constants/cdn-urls';
import { DefaultImageProps } from './types/index';

export const WebshopBackgroudGradient = ({ className, ...props }: DefaultImageProps) => (
  <img
    className={className}
    src={`${CDN_URLS.WEB_SHOP}/general/background-gradient.png`}
    alt="background-gradient"
    {...props}
  />
);
